export default __webpack_public_path__ + "static/media/cloud_composer.baf2b57f.svg";